const initialState = {
    shopTitle: '',
    branchTitle: '',
    shopId: 0,
    branchId: 0,
    services: [],
    serviceSelected: null,
    amount: '',
    disableBtn: true,
    btnClass: 'disable-btn',
};
const transfer = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_TRANSFER':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default transfer;
